import { Options } from 'shared/types/option';

export enum Roles {
  admin = 'ROLE_TOURNAMENT_ADMIN',
}

export const ROLES_OPTIONS: Options<Roles> = [
  {
    value: Roles.admin,
    label: 'Админ',
  },
];
